import React from "react";
import * as styles from "./OpenAndClose.module.scss";
import arrowWhite from "../../../icons/arrows/downArrowBlack.svg";

export const OpenAndClose = ({ toggleDropdown, name, isRotated }) => {

  return (
    <div className={styles.container} onClick={() => toggleDropdown()}>
      <button className={styles.button__products}>
        <p>{name}</p>
      </button>

      <div className={styles.container}>
        <div
          className={` ${isRotated === true ? styles.rotate : styles.rotate2}`}
        >
          <img src={arrowWhite} alt="Icono" />
        </div>
      </div>
    </div>
  );
};
